import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from '@material-ui/core/Select';
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from '@material-ui/core/MenuItem';

import { filterChange } from '../../actions/index';
import { _ } from '../../functions/translator';
import { Checkbox } from '@material-ui/core';
import { FilterActions } from '../../constants/constants';
import { sortStages } from '../../functions/utils';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 500,
            top: '0px',
            position: 'fixed',
        },
    },
    getContentAnchorEl: null,
};

class LevelDropdown extends React.Component{

    handleLevelsChange = (event) => {
        let levelIdsSelected = [];
        let stageSelected = null;
        for (const levelIdSelected of event.target.value) {
            const isAStage = typeof levelIdSelected === 'object';
            if (isAStage) {
                stageSelected = levelIdSelected;
            } else {
                levelIdsSelected.push(levelIdSelected);
            }
        }
        if (stageSelected) {
            levelIdsSelected = this.handleStageSelected(levelIdsSelected, stageSelected);
        }
        this.props.filterChange(FilterActions.LEVELS, levelIdsSelected);
    };

    renderSelectedValues = (levelsSelected) => {
        if (levelsSelected.length === 0) {
            return _('Pisos')
        } else {
            let levelNames = []
            for (const levelId of levelsSelected) {
                let levelData = this.props.levelsData[levelId.toString()]
                levelNames.push(levelData.attributes.name)
            }
            return levelNames.join(', ')
        }
    }

    handleStageSelected = (levelIdsSelected, stageSelected) => {
        const stageLevelsData = Object.values(this.props.levelsData).filter((levelData) => { 
            return levelData.attributes.stage_id === stageSelected.id;
        });
        const orderedLevelsData = stageLevelsData.sort((firstLevel, secondLevel) => {
            return firstLevel.attributes.height - secondLevel.attributes.height;
        })
        const stageLevelIds = orderedLevelsData.map((levelData) => {
            return levelData.id;
        })
        const stageLevelsSelected = stageLevelIds.map((levelId) => { 
            return levelIdsSelected.indexOf(levelId) !== -1;
        });
        const stageHasAllLevelsSelected = !stageLevelsSelected.includes(false);
        if (stageHasAllLevelsSelected) {
            levelIdsSelected = levelIdsSelected.filter((levelId) => {
                return !stageLevelIds.includes(levelId);
            });
        } else {
            stageLevelIds.forEach((levelId) => {
                if (!levelIdsSelected.includes(levelId)) {
                    levelIdsSelected.push(levelId);
                }
            });
        }
        return levelIdsSelected;
    }

    render() {
        const stagesArray = Object.values(this.props.stagesData);
        const sortedStages = sortStages(stagesArray);
        let levelsList = [];
        let orderedLevelsData = Object.values(this.props.levelsData).sort((firstLevel, secondLevel) => {
            return firstLevel.attributes.height - secondLevel.attributes.height;
        })
        for (const stageData of Object.values(sortedStages)) {
            if (this.props.stageIds.length > 0 && !this.props.stageIds.includes(stageData.id)) continue;
            levelsList.push(
                <ListSubheader color="inherit" value={stageData} classes={{root: 'cursor-pointer'}}>
                    {stageData.attributes.name}
                </ListSubheader>
            );
            for (const levelData of orderedLevelsData) {
                if (levelData.attributes.stage_id !== stageData.id) continue;
                levelsList.push(
                    <MenuItem key={levelData.id} value={levelData.id}>
                        <Checkbox color="primary" checked={this.props.levelIds.includes(levelData.id)} />
                        {levelData.attributes.name}
                    </MenuItem>
                )
            }
        }

        return(
            <div>
                <Select
                value={this.props.levelIds}
                multiple={true}
                displayEmpty={true}
                renderValue={this.renderSelectedValues}
                onChange={this.handleLevelsChange}
                MenuProps={MenuProps}>
                {levelsList}
                </Select>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        levelIds     : state.filters.levelIds,
        stageIds     : state.filters.stageIds,
        levelsData   : state.projectData.levels,
        stagesData   : state.projectData.stages,
        fullBuilding : state.switches.fullBuilding
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange : filterChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(LevelDropdown);